import {
  useMutation,
  useInfiniteQuery,
  useQueryClient,
} from "@tanstack/vue-query";
import APIClient from "@/APIClient";

export const CHANGELOG_QUERY_KEY = ["changelog"] as const;
const PAGE_SIZE = 10;

export const useChangelogInfiniteQuery = () => {
  return useInfiniteQuery({
    queryKey: CHANGELOG_QUERY_KEY,
    queryFn: ({ pageParam = 1 }) =>
      APIClient.getChangelog(pageParam as number, PAGE_SIZE),
    getNextPageParam: (lastPage) => {
      const fetched =
        (lastPage.page - 1) * lastPage.pageSize + lastPage.entries.length;
      return fetched < lastPage.total ? lastPage.page + 1 : undefined;
    },
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000,
  });
};

export const useMarkChangelogSeenMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => APIClient.markChangelogSeen(),
    onSuccess: () => {
      queryClient.setQueryData(CHANGELOG_QUERY_KEY, (old: any) => {
        if (!old) return old;
        return {
          ...old,
          pages: old.pages.map((page: any, i: number) => ({
            ...page,
            unseenCount: i === 0 ? 0 : page.unseenCount,
            entries: page.entries.map((e: any) => ({ ...e, isNew: false })),
          })),
        };
      });
    },
  });
};
